import { Select } from "antd";
import { useContext, useEffect, useState } from "react";
import { SpinContext } from "../../../../../component/Spin/spin.context";
import { spinActions } from "../../../../../component/Spin/spin.reducer";
import { CommentCategory, MComment } from "../../entity/product.model";
import { productService } from "../../service/product.service";
import CComment from "./CComment";

export interface MCommentsProps {
  productId: string;
}

function MComments(props: MCommentsProps) {
  const { Option } = Select;
  const { dispatch } = useContext(SpinContext);

  const [commentCategories, setCommentCategories] = useState<CommentCategory[]>(
    []
  );

  const [selectedCommentCategoryId, setSelectedCommentCategoryId] =
    useState<string>();

  const [comments, setComments] = useState<MComment[]>([]);

  useEffect(() => {
    dispatch({ type: spinActions.BLOCK });

    productService
      .getCommentsCategories("product")
      .then((x) => {
        setCommentCategories(x);

        if (x.length > 0) {
          dispatch({ type: spinActions.UNBLOCK });
          onCommentCategorySelected(x[0].uuid);
        }
      })
      .catch((e) => dispatch({ type: spinActions.UNBLOCK }));
  }, [props.productId]);

  const onCommentCategorySelected = (categoryId: string) => {
    setSelectedCommentCategoryId(categoryId);
    dispatch({ type: spinActions.BLOCK });

    productService
      .getProductComments(props.productId, categoryId)
      .then((x) => {
        setComments(x);
        dispatch({ type: spinActions.UNBLOCK });
      })
      .catch((e) => dispatch({ type: spinActions.UNBLOCK }));
  };

  return (
    <>
      <div className="form-group">
        <label>Сэтгэгдэлийн төрөл</label>
        <div>
          <Select
            placeholder="Сэтгэгдлийн төрөл сонгох"
            onChange={(value) => {
              onCommentCategorySelected(value);
            }}
            style={{ width: "100%" }}
            value={selectedCommentCategoryId}
          >
            {commentCategories.map((e) => (
              <Option key={e.uuid} value={e.uuid}>
                {e.name}
              </Option>
            ))}
          </Select>
        </div>
      </div>
      {comments.length > 0 ? (
        comments.map((e) => <CComment key={e.uuid} comment={e} />)
      ) : (
        <div className="media text-muted">Сэтгэгдэл олдсонгүй.</div>
      )}
    </>
  );
}

export default MComments;
